import {Injectable} from '@angular/core';
import {ModelMetadata} from '../../../decorators/ModelMetadata';


@Injectable({
  providedIn: 'root'
})
export class BaseConverter<ViewModel> {

  constructor() {
  }

  public toViewModels(response: any[], factory: () => ViewModel): ViewModel[] {
    return response.map((serverEntry) => this.toViewModel(serverEntry, factory));
  }

  public toViewModel(response: any, factory: () => ViewModel): ViewModel {
    const entry: ViewModel = factory();
    for (const attrName of Object.keys(entry)) {
      const attributeName = ModelMetadata.getProperties(entry, attrName, attrName);
      entry[attrName] = response[attributeName];
    }

    return entry;
  }

}
